export const cameraClassName = 'camera_class_name';
